import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { CustomerMediasQuery } from "@/queries";
import { graphqlClient } from "@/lib/graphql-client";
import { ResultOf } from "gql.tada";
export const useMedias = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["customer-medias"],
      queryFn: _temp2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};
export type CustomerMedias = ResultOf<typeof CustomerMediasQuery>["medias"];
export type CustomerMedia = CustomerMedias[number];
function _temp(res) {
  return res.medias;
}
function _temp2() {
  return graphqlClient.request(CustomerMediasQuery).then(_temp);
}